import { TextInput } from "@src/components/elements";
import { TextInputProps } from "@src/components/elements/TextInput";
import { AddressFormFieldsType } from "@src/components/modules/AddressForm/addressFormFieldsType";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { googleMapsContext } from "@src/contexts/GoogleMapsProvider";
import { match } from "ts-pattern";

type Props = {
  inputProps: TextInputProps;
  onAddressSelected: (address: AddressFormFieldsType) => void;
};

const className = ".google-maps-address-input";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
globalThis.gm_authFailure = () => {
  Array.from(document.getElementsByClassName(className)).map((e) => {
    const elem: HTMLInputElement = e as HTMLInputElement;
    elem.disabled = false;
    elem.placeholder = "";
    elem.focus();
  });
};

export const AddressAutocompleteInput: React.FC<Props> = ({
  inputProps,
  onAddressSelected,
}) => {
  const { AutocompleteService } = useContext(googleMapsContext);
  const inputRef = useRef<HTMLInputElement>(null);
  const [autocompleteService, setAutocompleteService] =
    useState<google.maps.places.Autocomplete>();

  const onPlaceSelected = useCallback(
    (place: google.maps.places.PlaceResult) => {
      const addressFields: AddressFormFieldsType = {
        address1: "",
        address2: "",
        city: "",
        state: "",
        country: "",
        postalCode: "",
      };

      place.address_components?.forEach((component) => {
        match(component.types[0])
          .with("street_number", () => {
            if (addressFields.address1.length > 0) {
              addressFields.address1 =
                component.long_name + " " + addressFields.address1;
            } else {
              addressFields.address1 = component.long_name;
            }
          })
          .with("route", () => {
            if (addressFields.address1.length > 0) {
              addressFields.address1 =
                addressFields.address1 + " " + component.long_name;
            } else {
              addressFields.address1 = component.long_name;
            }
          })
          .with("locality", () => {
            addressFields.city = component.long_name;
          })
          .with("administrative_area_level_1", () => {
            addressFields.state = component.short_name;
          })
          .with("country", () => {
            addressFields.country = component.long_name;
          })
          .with("country", () => {
            addressFields.country = component.long_name;
          })
          .with("postal_code", () => {
            addressFields.postalCode = component.long_name;
          })
          .otherwise(() => {
            //noop
          });
      });
      onAddressSelected(addressFields);
    },
    [onAddressSelected],
  );

  useEffect(() => {
    if (!AutocompleteService || !inputRef.current || !!autocompleteService)
      return;

    const autocomplete = new AutocompleteService(inputRef.current, {
      fields: ["address_components"],
      types: ["address"],
    });
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      onPlaceSelected(place);
    });
    setAutocompleteService(autocomplete);
  }, [AutocompleteService, autocompleteService, onPlaceSelected]);

  return (
    <TextInput {...inputProps} ref={inputRef} inputClassName={className} />
  );
};
